import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import SubscriptionContainer from "./SubscriptionContainer";

class SubscriptionsContainer extends Component {
  state = {
    subscriptions1: [],
    subscriptions2: []
  };

  UNSAFE_componentWillMount = () => {
    window.firebase
      .firestore()
      .collection("userStatus")
      .where("status", "==", 1)
      .onSnapshot(querySnapshot => {
        let subscriptions = [];
        querySnapshot.forEach(doc => {
          let subscription = doc.data();
          subscription["id"] = doc.id;
          subscriptions.push(subscription);
        });
        this.setState({ subscriptions1: subscriptions });
      });
    window.firebase
      .firestore()
      .collection("userStatus")
      .where("status", "==", 2)
      .onSnapshot(querySnapshot => {
        let subscriptions = [];
        querySnapshot.forEach(doc => {
          let subscription = doc.data();
          subscription["id"] = doc.id;
          subscriptions.push(subscription);
        });
        this.setState({ subscriptions2: subscriptions });
      });
  };

  render() {
    return (
      <div style={{ width: "100%", marginTop: 10 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>UID</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Package</TableCell>
              <TableCell>Notes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.subscriptions1.map(subscription => (
              <SubscriptionContainer
                key={subscription.id}
                uid={subscription.id}
                package="Worldclass"
                notes={subscription.notes || ""}
              />
            ))}
            {this.state.subscriptions2.map(subscription => (
              <SubscriptionContainer
                key={subscription.id}
                uid={subscription.id}
                package="Legendary"
                notes={subscription.notes || ""}
              />
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default SubscriptionsContainer;
